import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import CardHeaderSpan from '../../../../../Utils/CommonComponents/CardHeaderSpan'
import { Href, PopularTagsTitle } from '../../../../../Utils/Constants'
import { LI, UL } from '../../../../../AbstractElements'
import { popularTagsData } from '../../../../../Data/MiscellaneousData/BlogData'

export default function PopularTags() {
    return (
        <Col sm={12}>
            <Card>
                <CardHeaderSpan headingClassName='pb-0 border-0' smallHeading={PopularTagsTitle} />
                <CardBody>
                    <UL className="tags simple-list flex-row">
                        {popularTagsData.map((item, index) => (
                            <LI key={index}>
                                <a href={Href}>{item}</a>
                            </LI>
                        ))}
                    </UL>
                </CardBody>
            </Card>
        </Col>
    )
}